import React, { FC } from 'react'
import classnames from 'classnames/bind'

import styles from './LiveRegion.module.scss'

const cx = classnames.bind(styles)

const LiveRegion: FC<IProps> = ({ numOfSuggestionsText }) => (
  <div
    id="autocomplete-default__status--B"
    role="status"
    aria-atomic="true"
    aria-live="polite"
    className={cx('liveRegion')}
  >
    {numOfSuggestionsText}
  </div>
)

export interface IProps {
  /* The text to display for how many suggestions are available */
  numOfSuggestionsText: string
}

export default LiveRegion
